/**
 * Branded type for translated strings.
 * This is the single source of truth for TranslatedString type.
 * The web package imports this and adds i18next integration.
 */
declare const __brand: unique symbol;

export type TranslatedString = string & { readonly [__brand]: "TranslatedString" };

/**
 * Helper for dynamic content that can't be pre-translated.
 * Use for user-generated content, computed values, or API responses.
 */
export function untranslated(str: string): TranslatedString {
  return str as TranslatedString;
}
